
import React from 'react';
import { Title } from '@vds/typography';
import { Line } from '@vds/lines';
import styled from 'styled-components';
const Container = styled.div`
  margin-bottom: 5px;
  margin-top: 30px;
`;

class SideBannerMobile extends React.PureComponent {
    render() {
        return (
            <div className="row margin-vert-zero hide-for-medium-up  where-i-want" id="whereIwantSideBanner">
                <div className="column tiny-12 medium-12 padding-vert-zero margin-bottom-medium">
                    {/* <h4 className="text-black margin-bottom-medium BrandFontText hide-for-medium-up">
                    {this.props.bannerText}
                </h4> */}
                    <Title size="large" viewport="mobile" primitive="h4" color="black">
                        {this.props.bannerText}
                    </Title>
                    <Container>
                        <Line type="heavy" />
                    </Container>
                </div>
            </div>
        );
    }
}

export default SideBannerMobile;